import { render, staticRenderFns } from "./TaskReply.vue?vue&type=template&id=08ae8e7d"
import script from "./TaskReply.vue?vue&type=script&lang=js"
export * from "./TaskReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports